import React from "react";
import {
  Alert,
  Avatar,
  Button,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";
import { useState } from "react";

const { TextArea } = Input;
const EvaluateMoveOut = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {

    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <Alert
        message="Verify Tenant move out date and ensure it has not been cancelled."
        type="info"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      />

      <Form
        name="basic"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        layout="vertical"
      >
        <Form.Item label="Event" name="eventName">
          <Input placeholder="Type answer here..." />
        </Form.Item>

        <Form.Item label="Tenant" name="tenant">
          <Input placeholder="Type answer here..." />
        </Form.Item>

        <Form.Item label="Property Name" name="propertyName">
          <Input placeholder="Type answer here..." />
        </Form.Item>
        <Form.Item label="Move out Date" name="moveOutDate">
          <Input placeholder="Type answer here..." />
        </Form.Item>

        <Row justify="end" gutter={16}>
          <Col>
            <Button>Skip</Button>
          </Col>
          <Col>
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={isDisabled}>
                Complete
              </Button>
            </Form.Item>
          </Col>
        </Row>

        <Divider />

        <Row>
          <Col span={2}>
            <Avatar>KA</Avatar>
          </Col>
          <Col span={22}>
            <TextArea
              style={{
                height: 200,
                resize: "none",
              }}
              placeholder="Write a comment… Type @ to mention other users."
            />
          </Col>
        </Row>
        <Row justify="end" gutter={16}>
          <Col>
            <Upload>
              <Button style={{ marginTop: "10px" }}>
                <UploadOutlined />
              </Button>
            </Upload>
          </Col>
          <Col>
            <Button style={{ marginTop: "10px" }}>Send</Button>
          </Col>{" "}
        </Row>
      </Form>
    </div>
  );
};

export default EvaluateMoveOut;
